import { TFunction } from 'react-i18next';
import { IProductsQrType } from '@/models/generateQr.model';
import { IPartnerProfile } from '@/models/partners.model';

export const getQrTypesOptions = (t: TFunction) => [
  { value: IProductsQrType.A4_TYPE, label: t('generate_qr_type_a4') },
  { value: IProductsQrType.SMALL_TYPE, label: t('generate_qr_type_small') },
  { value: IProductsQrType.COMPACT_39_70, label: t('generate_qr_type_39x70') },
];

export const getPartnersOptions = (partners: IPartnerProfile[]) =>
  partners?.map((partner: IPartnerProfile) => ({ label: partner.store?.title ?? '', value: partner.store?.id ?? '' }));
